import AntIcon from "@ant-design/icons";

const Icon = ({ rotate, rotateAxis = "", style, ...props }) => (
  <AntIcon
    {...props}
    style={{
      transform: `rotate${rotateAxis.toUpperCase()}(${rotate}deg)`,
      transition: "transform 0.3s ease",
      ...style,
    }}
  />
);

export default Icon;
